export { default } from "./InfoPage";
